import React from "react";
import { Table } from "semantic-ui-react";

export const marriageContent = (
  <Table className={"coverage-area-table"}>
    <Table.Body>
      <Table.Row>
        <Table.HeaderCell colSpan={2}>Marriage/Divorce</Table.HeaderCell>
      </Table.Row>
      <Table.Row>
        <Table.Cell>
          <Table className={"coverage-area-inner-table"}>
            <Table.Body>
              <Table.Row>
                <Table.Cell className={"red-text"}>State</Table.Cell>
                <Table.Cell className={"red-text"}>Total Records</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>California</Table.Cell>
                <Table.Cell>4,909,257</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Colorado</Table.Cell>
                <Table.Cell>1,700,809</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Florida</Table.Cell>
                <Table.Cell>6,391,889</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Idaho</Table.Cell>
                <Table.Cell>198,124</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Indiana</Table.Cell>
                <Table.Cell>435,920</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Kentucky</Table.Cell>
                <Table.Cell>1,178,260</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Maine</Table.Cell>
                <Table.Cell>946,195</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Minnesota</Table.Cell>
                <Table.Cell>1,434,283</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Nevada</Table.Cell>
                <Table.Cell>10,229,237</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Ohio</Table.Cell>
                <Table.Cell>3,467,847</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Texas</Table.Cell>
                <Table.Cell>10,189,362</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Utah</Table.Cell>
                <Table.Cell>488,284</Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>Connecticut</Table.Cell>
                <Table.Cell>893,725</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        </Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
);
export default marriageContent;



// WEBPACK FOOTER //
// ./src/components/coveragearea/Marriage.js